import {
  IconArrowLeft,
  IconCheck,
  IconChecks,
  IconChevronDown,
  IconChevronRight,
  IconDna2,
  IconDots,
  IconDownload,
  IconEmpathize,
  IconFolderOpen,
  IconLoader,
  IconPaperclip,
  IconPlus,
  IconRefresh,
  IconStethoscope,
  IconMan,
  IconCheckupList,
  IconRosetteDiscountCheck,
  IconCirclePlus,
  IconCalendarWeek,
  IconNurse,
  IconBrandApplePodcast,
  IconLanguage,
  IconTrash,
  IconEdit,
  IconAlertOctagonFilled
} from '@tabler/icons-react';
import { ICON_TYPE } from '../constants/icons';

const iconHandler = (
  name: string,
  color: string,
  stroke: number,
  size: number,
  className?: string
) => {
  switch (name) {
    case ICON_TYPE.PLUS:
      return <IconPlus size={size} stroke={stroke} color={color} />;
    case ICON_TYPE.ARROW_DOWN:
      return <IconChevronDown size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.ARROW_RIGHT:
      return <IconChevronRight size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.SINGLE_TICK:
      return <IconCheck size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.DOUBLE_TICK:
      return <IconChecks size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.DOWNLOAD:
      return <IconDownload size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.ATTACHMENT:
      return <IconPaperclip size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.LOADING:
      return <IconLoader size={size} stroke={stroke} color={color} className={className} />;

    case ICON_TYPE.REFRESH:
      return <IconRefresh size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.THREEDOT:
      return <IconDots size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.DNA2:
      return <IconDna2 size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.EMPATHIZE:
      return <IconEmpathize size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.STETHOSCOPE:
      return <IconStethoscope size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.ARROW_LEFT:
      return <IconArrowLeft size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.MAN:
      return <IconMan size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.CHECKUPLIST:
      return <IconCheckupList size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.DISCOUNTCHECK:
      return <IconRosetteDiscountCheck size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.CIRCLEPLUS:
      return <IconCirclePlus size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.CALENDARWEEK:
      return <IconCalendarWeek size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.APPLEPODCAST:
      return <IconBrandApplePodcast size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.PEOPLEDOCTOR:
      return <IconNurse size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.NURSE:
      return <IconNurse size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.LANGUAGE:
      return <IconLanguage size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.TRASH:
      return <IconTrash size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.EDIT:
      return <IconEdit size={size} stroke={stroke} color={color} />;

    case ICON_TYPE.ALERTOCTAGON:
      return <IconAlertOctagonFilled size={size} stroke={stroke} color={color} />;

    default:
      return <IconFolderOpen size={size} stroke={stroke} color={color} />;
  }
};

export { iconHandler };
